import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginGuard } from "../core/guards/login.guard";

import { MaintenanceUserComponent } from "./maintenance-user.component";
import { ListUsersComponent } from "./list-users/list-users.component";
import { MantenerUsuarioSelectedComponent } from "./usuarioSelected/app.mantenerUsuario.usuarioSelected";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";

const routesUser: Routes = [
  {
    path: "",
    component: MaintenanceUserComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
    children: [
      {
        path: "lista",
        component: ListUsersComponent,
      },
      {
        path: "creacion",
        component: MantenerUsuarioSelectedComponent,
        data: {
          operation: "creacion",
        },
      },
      {
        path: "edicion/:id",
        component: MantenerUsuarioSelectedComponent,
        data: {
          operation: "edicion",
        },
      },
      {
        path: "mod-datos-pers",
        component: MantenerUsuarioSelectedComponent,
        canActivate: [LoginGuard, PwdExpiratedGuard],
        data: {
          operation: "mod-datos-pers",
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesUser)],
  exports: [RouterModule],
})
export class MaintenanceUserRoutingModule {}
